import React from 'react';
import DVRList from './DVRList';
import DVRFilters from '../filters/HealthFilterBar';

const DVRhealth = props => {
  return (
    <div>
      {!props.isMobile && <DVRFilters />}
      <DVRList />
    </div>
  );
};

export default DVRhealth;
